export default {
  steps: {
    of: 'Step {current} of {total}',
    title: {
      1: 'Find your user',
      2: 'Review refundable amount',
      3: 'Input your bank account'
    }
  },
  refunds: 'Refunds',
  actions: {
    accept: 'Accept'
  },
  main: {
    start: 'Start refund process',
    refund_unavailable: 'Refund process currently unavailable.'
  },
  tagId: {
    label: 'Wristband ID or User ID',
    validate: 'Validate',
    tag_placement:
      'You can find your chip ID on the front or back of your chip.',
    id_description: `It's a 14 or 15 digit long string of numbers and letters.`
  },
  balance: {
    current: 'Current balance',
    comission: 'Refund comission',
    total: 'Total refund',
    refund: 'Proceed to refund',
    message: {
      not_enough_balance: 'Refund unavailable. Refund comission is greater that your current balance.'
    }
  },
  bank_data: {
    document: 'Document',
    name: 'Name',
    surname: 'First surname',
    second_surname: 'Second surname',
    phone: 'Phone number',
    email: 'E-mail',
    document_type: 'Type',
    confirm_refund: 'Confirm {amount} refund',
    hint: {
      phone: 'Include your country code: +34 666 666 666'
    },
    document_types: {
      NATIONAL_ID_CARD: 'National ID card',
      PASSPORT: 'Passport',
      ARG_TAX_DOCUMENT: 'CUIL/CUIT',
      MEXICAN_RFC: 'Mexican RFC',
      UYU_CI: 'CI Uruguay'
    },
    account_types: {
      IBAN: 'IBAN',
      CBU: 'CBU',
      CLABE: 'CLABE',
      UYU_ACCOUNT: 'UYU Account'
    }
  },
  result: {
    back_to_main: 'Go back to main page'
  },
  error: {
    not_found: {
      title: `Oops! There's nothing here`,
      subheading: 'Use the provided link to load this app',
      tag: 'This tag was not used for this event'
    },
    500: `Something broke on the server. We're working on it!`,
    0:
      'Oops! It seems like the server is unavailable. Come back later!',
    bad_request: {
      any: {
        required: 'Required',
        empty: 'Required'
      },
      string: {
        base: 'Required',
        hex: 'Invalid chip ID. It should have 14 or 15 digits.',
        invalid_tag: 'Invalid chip ID. Check your digits.',
        min: `Doesn't reach min length`
      },
      iban: {
        invalid: 'Invalid IBAN'
      },
      cbu: {
        invalid: 'Invalid CBU'
      },
      clabe: {
        invalid: 'Invalid CLABE'
      },
      uyu_account: {
        invalid: 'Incorrect length, should be 14 digits'
      },
      email: {
        invalid: 'Invalid e-mail'
      },
      phone: {
        invalid: 'Invalid phone number. Include your country code: +34 666 666 666'
      },
      cuil_cuit: {
        invalid: 'Invalid CUIL/CUIT'
      },
      mexican_rfc: {
        invalid: 'Invalid mexican RFC'
      }
    }
  },
  message: {
    close: 'Close message'
  },
  decimal_separator: '.',
  warnings: {
    important: 'Important: ',
    complete_name: 'Full name and surname must be filled in, otherwise the refund might not be correctly processed.'
  }
}
